//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TagBadge from '~/components/Shared/TagBadge'
import { getAllExperiences } from '~/util/entity/user'

export default {
  components: {
    TagBadge,
  },
  props: {
    person: {
      type: Object,
      default: () => ({}),
    },
    position: {
      type: String,
      default: '',
    },
    statusLabel: {
      type: String,
      default: '',
    },
  },
  computed: {
    fullNames() {
      return `${this.person.names} ${this.person.lastnames}`
    },
    totalSkills() {
      return [...new Set(this.person.skills.map(({ skill }) => skill.id))]
        .length
    },
    totalExperiences() {
      return getAllExperiences(this.person).length
    },
    totalQuestionaries() {
      return (
        (this.person.questionaries?.length || 0) +
        (this.person.model_questionaries?.length || 0)
      )
    },
    getProjectName() {
      // Si es solo empleado, colaborador, colaborador/supervisor
      if (this.person.project) {
        return this.person.project.name
      }
      // Si es supervisor de varios proyectos, devuelve el más reciente
      if (this.person?.supervisorProjects?.length > 0) {
        const orderedProjects = [...this.person.supervisorProjects].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        )
        return orderedProjects[0].name
      }
      return 'Sin proyecto'
    },
    projectsExtraNumber() {
      // Si es colaborador/supervisor
      if (this.person.project && this.person?.supervisorProjects?.length > 0) {
        return ` +${this.person.supervisorProjects?.length}`
      }

      // Si es solo supervisor con varios proyectos
      if (!this.person.project && this.person?.supervisorProjects?.length > 1) {
        return ` +${this.person.supervisorProjects?.length - 1}`
      }

      // Si es solo empleado o colaborador o
      // Si es solo supervisor con un solo proyecto
      return ''
    },
  },
  methods: {
    positionTooltip(text) {
      if (text.length > 200) {
        return 'is-left'
      }
      return 'is-top'
    },
  },
}
